import React, { useEffect, useState } from 'react';
import { getPlans } from '../../services/planService';
import { createGiftCheckoutSession } from '../../services/paymentService';

const formatPrice = (cents) => `$${(cents / 100).toFixed(2)}`;

const BuyGift = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [purchasingKey, setPurchasingKey] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const data = await getPlans();
        setPlans(data.plans);
      } catch (err) {
        setError('Failed to load plans');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const handleBuy = async (planKey) => {
    setPurchasingKey(planKey);
    setError('');
    try {
      const data = await createGiftCheckoutSession(planKey);
      window.location.href = data.url;
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to start checkout');
      setPurchasingKey(null);
    }
  };

  if (loading) return <p style={styles.status}>Loading plans...</p>;

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>🎁 Give the Gift of a Shared Cookbook</h2>
      <p style={styles.subtitle}>
        Buy a plan for someone else — you'll get a redeemable code to share with them
        (by text, email, or however you like). They redeem it when they create their own cookbook.
        No account needed on their end until they're ready.
      </p>

      {error && <p style={styles.error}>{error}</p>}

      <div style={styles.grid}>
        {plans.map((plan) => (
          <div key={plan.plan_key} style={styles.card}>
            <h3 style={styles.planName}>{plan.name}</h3>
            <p style={styles.price}>{formatPrice(plan.price_cents)}</p>
            <p style={styles.planDetail}>Up to {plan.max_members} members</p>
            <p style={styles.planDetail}>{plan.included_scans} AI recipe scans included</p>
            <button
              onClick={() => handleBuy(plan.plan_key)}
              style={styles.buyBtn}
              disabled={purchasingKey === plan.plan_key}
            >
              {purchasingKey === plan.plan_key ? 'Redirecting...' : `Gift ${plan.name}`}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: { maxWidth: '700px', margin: '0 auto', textAlign: 'center' },
  title: { color: '#e67e22', fontSize: '24px', marginBottom: '10px' },
  subtitle: { color: '#888', fontSize: '14px', marginBottom: '28px', lineHeight: 1.6, maxWidth: '520px', marginLeft: 'auto', marginRight: 'auto' },
  grid: { display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' },
  card: {
    backgroundColor: 'white', padding: '28px', borderRadius: '12px', width: '220px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
  },
  planName: { color: '#333', marginBottom: '6px' },
  price: { fontSize: '28px', fontWeight: '700', color: '#e67e22', margin: '8px 0' },
  planDetail: { color: '#888', fontSize: '13px', marginBottom: '4px' },
  buyBtn: {
    width: '100%', padding: '10px', backgroundColor: '#e67e22', color: 'white', border: 'none',
    borderRadius: '8px', fontWeight: '600', cursor: 'pointer', marginTop: '14px',
  },
  status: { textAlign: 'center', color: '#999' },
  error: { color: '#e74c3c', textAlign: 'center', marginBottom: '16px' },
};

export default BuyGift;
